module.exports = __webpack_public_path__ + "static/media/sport-min.86f276ae.jpg";